import React from 'react';
import { useIntl } from 'react-intl';
import { DatedEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { FilledFormSapAttribute } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';
import { useEvidencePermission } from '@utils';
import { useColumns } from './filled-form-attribute-columns';
import { Fields } from './filled-form-attribute-fields';
import { useValidationSchema } from './filled-form-attribute-schema';

export function FilledFormAttributes() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();
  const columns = useColumns();

  const btnPermissions = useEvidencePermission({
    options: {
      NEW: [Permission.FILLED_FORM_SAP_ATTRIBUTE_WRITE],
      EDIT: [Permission.FILLED_FORM_SAP_ATTRIBUTE_WRITE],
      REMOVE: [Permission.FILLED_FORM_SAP_ATTRIBUTE_WRITE],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<FilledFormSapAttribute>({
    identifier: 'FILLED_FORM_ATTRIBUTE',
    apiProps: {
      url: EvidenceApiUrl.FILLED_FORM_ATTRIBUTES,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__FILLED_FORM_ATTRIBUTE__TABLE__TITLE',
        defaultMessage: 'SAP atribúty formulárov',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__FILLED_FORM_ATTRIBUTE__DETAIL__TITLE',
          defaultMessage: 'SAP atribút formulára',
        }),
        showBtn: btnPermissions,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
